import { SubscriptionTier } from 'types';
import formatTierQuantity from './formatTierQuantity';

const isFlatFeeTier = (tier: SubscriptionTier): boolean => Boolean(
    tier.flat_amount_decimal || tier.flat_amount,
);

const formatQuantityLabel = (quantity: number, unit: string): string => {
    const count = quantity.toLocaleString();
    if (!unit || unit === 'unit') {
        return count;
    }

    const unitLabel = new Intl.PluralRules('en-US', { type: 'cardinal' }).select(quantity) === 'one'
        ? unit.slice(0, -1)
        : unit;

    return `${count} ${unitLabel}`;
};

export default function formatTierRange(
    tierIndex: number,
    tiers: SubscriptionTier[],
    unit: string,
): string {
    const tier = tiers[tierIndex];
    const previousCeiling = tierIndex === 0 ? 0 : (tiers[tierIndex - 1].up_to ?? 0);
    const currentCeiling = tier.up_to;
    const previousDisplay = formatTierQuantity(previousCeiling, unit);
    const start = previousDisplay === 0 ? 1 : previousDisplay + 1;
    const end = currentCeiling == null ? null : formatTierQuantity(currentCeiling, unit);

    if (isFlatFeeTier(tier)) {
        if (end == null) {
            return 'Flat fee';
        }
        return `Flat fee for ${formatQuantityLabel(end, unit)}`;
    }

    if (end == null) {
        return `${formatQuantityLabel(start, unit)} and above`;
    }

    return `From ${start.toLocaleString()} to ${formatQuantityLabel(end, unit)}`;
}
